module.exports = __webpack_public_path__ + "static/media/icon-mp3.8e785e1a.svg";